export default __webpack_public_path__ + "static/media/lee_naish.3f9e643c.png";